/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuthScopes } from './AuthScopes';
import {
    AuthScopesFromJSON,
    AuthScopesFromJSONTyped,
    AuthScopesToJSON,
} from './AuthScopes';
import type { Org } from './Org';
import {
    OrgFromJSON,
    OrgFromJSONTyped,
    OrgToJSON,
} from './Org';
import type { FeatureFlag } from './FeatureFlag';
import {
    FeatureFlagFromJSON,
    FeatureFlagFromJSONTyped,
    FeatureFlagToJSON,
} from './FeatureFlag';

/**
 * 
 * @export
 * @interface MyScopes
 */
export interface MyScopes {
    /**
     * 
     * @type {boolean}
     * @memberof MyScopes
     */
    tokenRefreshNeeded: boolean;
    /**
     * 
     * @type {Array<Org>}
     * @memberof MyScopes
     */
    accessibleCustomers: Array<Org>;
    /**
     * 
     * @type {boolean}
     * @memberof MyScopes
     */
    isGambytAdmin: boolean;
    /**
     * 
     * @type {Array<FeatureFlag>}
     * @memberof MyScopes
     */
    enabledFeatures: Array<FeatureFlag>;
    /**
     * 
     * @type {Array<AuthScopes>}
     * @memberof MyScopes
     */
    userScopes: Array<AuthScopes>;
}

/**
 * Check if a given object implements the MyScopes interface.
 */
export function instanceOfMyScopes(value: object): value is MyScopes {
    if (!('tokenRefreshNeeded' in value) || value['tokenRefreshNeeded'] === undefined) return false;
    if (!('accessibleCustomers' in value) || value['accessibleCustomers'] === undefined) return false;
    if (!('isGambytAdmin' in value) || value['isGambytAdmin'] === undefined) return false;
    if (!('enabledFeatures' in value) || value['enabledFeatures'] === undefined) return false;
    if (!('userScopes' in value) || value['userScopes'] === undefined) return false;
    return true;
}

export function MyScopesFromJSON(json: any): MyScopes {
    return MyScopesFromJSONTyped(json, false);
}

export function MyScopesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyScopes {
    if (json == null) {
        return json;
    }
    return {
        
        'tokenRefreshNeeded': json['tokenRefreshNeeded'],
        'accessibleCustomers': ((json['accessibleCustomers'] as Array<any>).map(OrgFromJSON)),
        'isGambytAdmin': json['isGambytAdmin'],
        'enabledFeatures': ((json['enabledFeatures'] as Array<any>).map(FeatureFlagFromJSON)),
        'userScopes': ((json['userScopes'] as Array<any>).map(AuthScopesFromJSON)),
    };
}

export function MyScopesToJSON(value?: MyScopes | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'tokenRefreshNeeded': value['tokenRefreshNeeded'],
        'accessibleCustomers': ((value['accessibleCustomers'] as Array<any>).map(OrgToJSON)),
        'isGambytAdmin': value['isGambytAdmin'],
        'enabledFeatures': ((value['enabledFeatures'] as Array<any>).map(FeatureFlagToJSON)),
        'userScopes': ((value['userScopes'] as Array<any>).map(AuthScopesToJSON)),
    };
}

